module.exports = __webpack_public_path__ + "static/media/ALF Core Training Course_Updated- Dr_1618846415882.9da58933. Peterson";